import type { LicenseClass } from '../model.ts';

const LICENSE_CLASS_LABEL: Record<LicenseClass, string> = {
  SMALL_CAR: '小型車普通駕駛執照',
  BIG_TRUCK: '大貨車普通駕駛執照',
  BIG_BUS: '大客車普通駕駛執照',
  TRAILER: '聯結車普通駕駛執照',
  SMALL_CAR_PROFESSIONAL: '小型車職業駕駛執照',
  BIG_TRUCK_PROFESSIONAL: '大貨車職業駕駛執照',
  BIG_BUS_PROFESSIONAL: '大客車職業駕駛執照',
  TRAILER_PROFESSIONAL: '聯結車職業駕駛執照',
  SMALL_LIGHT_MOTORCYCLE: '小型輕型機車駕駛執照',
  ORDINARY_LIGHT_MOTORCYCLE: '普通輕型機車駕駛執照',
  ORDINARY_HEAVY_MOTORCYCLE: '普通重型機車駕駛執照',
  LARGE_HEAVY_MOTORCYCLE: '大型重型機車駕駛執照',
  INTERNATIONAL: '國際駕駛執照',
  MILITARY: '軍用駕駛執照',
};

const CAR_LICENSE_CLASSES: LicenseClass[] = [
  'SMALL_CAR',
  'BIG_TRUCK',
  'BIG_BUS',
  'TRAILER',
  'SMALL_CAR_PROFESSIONAL',
  'BIG_TRUCK_PROFESSIONAL',
  'BIG_BUS_PROFESSIONAL',
  'TRAILER_PROFESSIONAL',
];

const MOTORCYCLE_LICENSE_CLASSES: LicenseClass[] = [
  'SMALL_LIGHT_MOTORCYCLE',
  'ORDINARY_LIGHT_MOTORCYCLE',
  'ORDINARY_HEAVY_MOTORCYCLE',
  'LARGE_HEAVY_MOTORCYCLE',
];

const OTHER_LICENSE_CLASSES: LicenseClass[] = ['INTERNATIONAL', 'MILITARY'];

const toOptions = (classes: LicenseClass[]) =>
  classes.map((value) => ({ value, label: LICENSE_CLASS_LABEL[value] }));

/** 依 PRD 以汽車／機車分組顯示 */
const LICENSE_CLASS_OPTIONS = [
  { group: '汽車', items: toOptions(CAR_LICENSE_CLASSES) },
  { group: '機車', items: toOptions(MOTORCYCLE_LICENSE_CLASSES) },
  { group: '其他', items: toOptions(OTHER_LICENSE_CLASSES) },
];

export { LICENSE_CLASS_LABEL, LICENSE_CLASS_OPTIONS };
